import debounce from 'lodash.debounce'

function accordianInit(className) {
    const accordianBlockList = document.querySelectorAll(className)
    accordianBlockList.forEach(accordianBlock => {
        const accordianList = accordianBlock.querySelectorAll('.accordion-component__button')

        function setAccordionMaxHeight(item) {
            const ariaExpanded = item.getAttribute('aria-expanded')
            if(ariaExpanded === 'true') {
                const accordionContentHeight = item.nextElementSibling.querySelector('.accordion-component__content-holder').offsetHeight
                item.nextElementSibling.style.maxHeight = `${accordionContentHeight}px`
            }
        }

        function toggleAccordion() {
            const itemToggle = this.getAttribute('aria-expanded')
            const accordionContentWrapper = this.nextElementSibling
            accordionContentWrapper.style.maxHeight = '0px'
            for (let i = 0; i < accordianList.length; i++) {
                accordianList[i].setAttribute('aria-expanded', 'false')
                accordianList[i].nextElementSibling.style.maxHeight = '0px'
            }
            if (itemToggle == 'false') {
                this.setAttribute('aria-expanded', 'true')
                setAccordionMaxHeight(this)
                window.addEventListener('resize', debounce(() => {
                    setAccordionMaxHeight(this)
                }, 20))
            }
        }
        accordianList.forEach(item => item.addEventListener('click', toggleAccordion))
    })
}

export default accordianInit